import BodyView from "@/layout/BodyView.vue";

import POS from "@/pages/sales/pos/Index.vue";
import SalesOrder from "@/pages/sales/sales-order/Index.vue";
import OrderHistory from "@/pages/sales/order-history/Index.vue";
import SalesClosing from "@/pages/sales/sales-closing/Index.vue";
import Comission from "@/pages/sales/comission/Index.vue";  
import ReportOrder from "@/pages/sales/report-order/Index.vue";
import ReportComission from "@/pages/sales/report-comission/Index.vue";
import OrderInteraction from "@/pages/sales/order-interaction/Index.vue";

export const route = {
  path: "/sales",
  component: BodyView,
  children: [
    {
      path: "order-interaction",
      name: "order-interaction",
      component: OrderInteraction,
      meta: {
        title: 'Order Interaction | INDOFORCETECH',
      }
    },
    {
      path: "pos",
      name: "pos",
      component: POS,
      meta: {
        title: 'Point Of Sales | INDOFORCETECH',
      }
    },
    {
      path: "order-history",
      name: "order-history",
      component: OrderHistory,
      meta: {
        title: 'Order History | INDOFORCETECH',
      }
    },
    {
      path: "sales-order",
      name: "sales-order",
      component: SalesOrder,
      meta: {
        title: 'Sales Order | INDOFORCETECH',
      }
    },
    {
      path: "sales-closing",
      name: "sales-closing",
      component: SalesClosing,
      meta: {
        title: 'Sales Closing | INDOFORCETECH',
      }
    },
    {
      path: "comission",
      name: "comission",
      component: Comission,
      meta: {
        title: 'Comission | INDOFORCETECH',
      }
    },
    {
      path: "report-order",
      name: "report-order",
      component: ReportOrder,
      meta: {
        title: 'Report Order | INDOFORCETECH',
      }
    },
    {
      path: "report-comission",
      name: "report-comission",
      component: ReportComission,
      meta: {
        title: 'Report Comission | INDOFORCETECH',
      }
    }
  ]
}